import { render, staticRenderFns, recyclableRender, components } from "./question-collection.vue?vue&type=template&id=005a2cf0&scoped=true&"
var renderjs
import script from "./question-collection.vue?vue&type=script&lang=js&"
export * from "./question-collection.vue?vue&type=script&lang=js&"
import style0 from "./question-collection.vue?vue&type=style&index=0&id=005a2cf0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../Applications/HBuilderX.app/Contents/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "005a2cf0",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "pages/question-bank/question-collection.vue"
export default component.exports